<div class="toast-container">
  <div
    *ngFor="let toast of toasts$ | async"
    class="toast-item toast-item--{{toast.type}}"
    (click)="dismiss(toast)"
  >
    <span class="toast-item__icon">{{ toast.type === 'success' ? '✓' : '✕' }}</span>
    <span>{{ toast.message }}</span>
  </div>
</div>
